import { fetch } from '../request';
import type { IResponse, IEquity, ORDER_TYPE, IPaginatedConfig, IPageResponse } from '../interface';
import type { IOrder } from '../interface/order';

// /order/client/upgrade_price/
export function getOrderUpgradePrice() {
  return fetch<IResponse<IEquity[]>>('/order/client/upgrade_price/', {
    method: 'GET',
    autoErrorHandle: false,
  });
}

// /order/client/check_purchase_limit/
export function getOrderCheckPurchaseLimit(data: { order_type: ORDER_TYPE }) {
  return fetch<IResponse<IEquity[]>>('/order/client/check_purchase_limit/', {
    method: 'GET',
    params: data,
  });
}

// /order/client/refund_available_orders/
export function getOrderRefundAvailableOrders(data: IPaginatedConfig) {
  return fetch<IPageResponse<IOrder>>('/order/client/refund_available_orders/', {
    method: 'GET',
    params: data,
  });
}

// /order/client/refund/
export interface IOrderRefund {
  order_no: string;
  name: string;
  phone_number: string;
  refund_reason: string;
  attachments: string[];
}

export function postOrderRefund(data: IOrderRefund) {
  return fetch<IResponse<IEquity>>('/order/client/refund/', {
    method: 'POST',
    body: data,
  });
}
